<template>
  <v-row>
    <v-col> 
      <div 
        class="text-h5 my-5"
      >
        {{ $t('Entitycontacts') }}
      </div>
      <v-text-field
        ref="entityPhone"
        :value="entityContact?.phone"
        :label="$t('Phone')"
        autocomplete="off"
        :rules="[rules.phone]"
        dense
        class="mb-4"
        @input="updateField('phone', $event)"
      ></v-text-field>
      <v-text-field
        ref="entityCommercialPhone"
        :value="entityContact?.commercialPhone"
        :label="$t('Commercialphone')"
        autocomplete="off"
        :rules="[rules.phone]"
        dense
        class="mb-4"
        @input="updateField('commercialPhone', $event)"
      ></v-text-field>
      <v-text-field
        ref="entityEmail"
        :value="entityContact?.email"
        :label="$t('Email')"
        autocomplete="off"
        :rules="[rules.email]"
        dense
        type="email"
        class="mb-4"
        @input="updateField('email', $event)"
      ></v-text-field>
      <v-text-field
        ref="entityInvoicingEmail"
        :value="entityContact?.invoicingEmail"
        :label="$t('Invoicingemail')"
        autocomplete="off"
        :rules="[rules.email]"
        dense
        type="email"
        class="mb-4"
        @input="updateField('invoicingEmail', $event)"
      ></v-text-field>
      <v-text-field
        ref="entityTrainingEmail"
        :value="entityContact?.trainingEmail"
        :label="$t('Trainingemail')"
        autocomplete="off"
        :rules="[rules.email]"
        dense
        type="email"
        @input="updateField('trainingEmail', $event)"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'HdEntityContactFields',
  props: {
    entityContact: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {
        phone: v => {
          if (!v) return true // Skip validation if empty
          const pattern = /^[\d*#+\-() ]+$/ //Numbers and specific special characters allowed
          return pattern.test(v) || this.$t('PhoneError')
        },
        email: v => {
          if (!v) return true // Skip validation if empty
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z,_\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(v) || this.$t('EmailAddressError')
        },
      }
    }
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { ...this.entityContact, [field]: value })
    },
    getValues() {
      return {
        phone: this.$refs.entityPhone?.internalValue || null,
        commercialPhone: this.$refs.entityCommercialPhone?.internalValue || null,
        email: this.$refs.entityEmail?.internalValue || null,
        invoicingEmail: this.$refs.entityInvoicingEmail?.internalValue || null,
        trainingEmail: this.$refs.entityTrainingEmail?.internalValue || null,
      }
    },
    reset(entityContact = {}) {
      // Safely set values with null checks
      if (this.$refs.entityPhone) {
        this.$refs.entityPhone.internalValue = entityContact?.phone || null
      }
      if (this.$refs.entityCommercialPhone) {
        this.$refs.entityCommercialPhone.internalValue = entityContact?.commercialPhone || null
      }
      if (this.$refs.entityEmail) {
        this.$refs.entityEmail.internalValue = entityContact?.email || null
      }
      if (this.$refs.entityInvoicingEmail) {
        this.$refs.entityInvoicingEmail.internalValue = entityContact?.invoicingEmail || null
      }
      if (this.$refs.entityTrainingEmail) {
        this.$refs.entityTrainingEmail.internalValue = entityContact?.trainingEmail || null
      }
    }
  }
}
</script>